'use client';

import { TeaserAlways as TeaserAlwaysType } from '@/shared/types/teasers';
import HIHButton from '../base/HIHButton';
import { URL_PAGE_ALWAYS } from '@/shared/constants';
import SingleArticleMobileFullViewCard from '../base/SingleArticleMobileFullviewCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useEffect, useState } from 'react';
import { updateSlidesOffset } from '@/utils/updateSlidesOffset';
import { ArticleCard } from '@/sanity/fetchArticles';
import React from 'react';
import layoutStyles from '@/styles/section-layouts.module.scss';
import styles from './TeaserAlways.module.scss';

export default function TeaserAlways({
  teaser,
  className,
}: {
  teaser: TeaserAlwaysType;
  className?: string;
}) {
  const { title, copy, linkLabel, linkPath } = teaser;
  const buttonLink = linkPath || URL_PAGE_ALWAYS;
  const [slidesOffsetBefore, setSlidesOffsetBefore] = useState(16); // Default offset
  const titleParts = title.split(/(?<=,)/);

  // Set the Offset for the slider based on window width
  useEffect(() => {
    updateSlidesOffset(setSlidesOffsetBefore); // Update on mount
    window.addEventListener('resize', () => updateSlidesOffset(setSlidesOffsetBefore)); // Add resize listener

    // Cleanup function to remove the event listener on component unmount
    return () => {
      window.removeEventListener('resize', () =>
        updateSlidesOffset(setSlidesOffsetBefore),
      );
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return (
    <div className={className}>
      <div className={[layoutStyles.containerContent, styles.header].join(' ')}>
        <div className={styles.headerInner}>
          <div className={styles.title}>
            {titleParts.map((part, index) => (
              <React.Fragment key={index}>
                {part}
                {index < titleParts.length - 1 && (
                  <>
                    <br />
                  </>
                )}{' '}
                {/* Add a line break after the part if it's not the last segment */}
              </React.Fragment>
            ))}
          </div>
          <div className={styles.sidebar}>
            <div className={styles.buttonWrapper}>
              <HIHButton link={buttonLink} title={linkLabel} variant="secondary" />
            </div>
            <div className={styles.copy}>{copy}</div>
          </div>
        </div>
      </div>

      {teaser.articles.length > 0 && (
        <div className={styles.articlesSection}>
          <div className={[layoutStyles.containerContent, styles.desktopGrid].join(' ')}>
            {teaser.articles.map((article: ArticleCard) => (
              <SingleArticleMobileFullViewCard key={article._id} article={article} />
            ))}
          </div>

          <div className={styles.mobileSlider}>
            <Swiper
              slidesPerView={'auto'}
              spaceBetween={16}
              className={['swiper', styles.swiperFull].join(' ')}
              slidesOffsetBefore={slidesOffsetBefore}
              slidesOffsetAfter={16}
            >
              {teaser.articles.map((article) => (
                <SwiperSlide key={article._id} className={styles.mobileSlide}>
                  <SingleArticleMobileFullViewCard article={article} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
}
